import React from "react";
import "@styles/PayoutManagement/PayoutManagement.css";
import PayoutTable from "./PayoutTable";

const PayoutManagement = () => {
  
  return (
    <div className="container">
      <div className="payout-card">
        <h2 className="header">Payout Management</h2>
        <p>Overview and manage daily payouts to food court owners.</p>
        <div className="payout-list">
          <div className="payoutheader">
            <h2 className="header">Payouts List</h2>
            <div>
              <div style={{ display: "flex", gap: "15px" }}>
                <div>
                  <div className="search-box2">
                    <button>
                      <i className="bx bx-search" />
                    </button>
                    <input type="text" placeholder="Search..." />
                  </div>
                </div>
                <div>
                  {" "}
                  <div className="dropdown">
                    <select
                      className="dropdown2-btn"

                      // value={selectedDateType}
                      // onChange={handleDateTypeChange}
                    >
                      <option value="">Date types</option>
                      <option value="Year">Year</option>
                      <option value="Month">Month</option>
                      <option value="Today">Today</option>
                    </select>
                  </div>
                </div>
                <div>
                  <div className="dropdown">
                    <button className="dropdown2-btn">
                      <i
                        className="bx bx-filter"
                        style={{ marginRight: "4px" }}
                      />
                      Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="payouttable">
            <PayoutTable/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayoutManagement;
